export default {
  title: 'Artigos',
};
